import ShapeBase from './ShapeBase';
import weakRelationship from '../assets/icons/weak_relationship.svg';
import { svgToIcon } from '../utils/svg';
import type Shape from '../objects/Shape';

class ShapeWeakRelationship extends ShapeBase {
  // There is a challenge to make this shape look good next to the WeakEntity,
  // since this shape is inherently smaller. The 'thinner' the inner shape is,
  // the better it looks as it scales. But, this means it might have smaller
  // inner borders than WeakEntity
  constructor(fabricObject: Shape) {
    super(fabricObject);

    // Set min scale to avoid drawing inner lines outside of shape
    fabricObject.minScaleLimit = (this.offset() / 100) * 2.5;
  }

  static renderIcon() {
    return svgToIcon(weakRelationship);
  }

  offset() {
    return 10;
  }

  calcTextMargin() {
    const { height, width } = this.fabricObject;

    const horizontalBound = (width / 2 + this.horizontalOffset()) / 2;
    const verticalBound = (height / 2 + this.verticalOffset()) / 2;

    return {
      top: verticalBound,
      left: horizontalBound,
      right: horizontalBound,
      bottom: verticalBound,
    };
  }

  render(ctx: CanvasRenderingContext2D) {
    const obj = this.fabricObject;
    const { width, height, scaleX, scaleY } = obj;
    const w = width;
    const h = height;
    const sw = width * scaleX;
    const sh = height * scaleY;

    const alpha = Math.atan(sw / sh);
    const beta = Math.atan(sh / sw);

    const vertical = this.offset() / scaleX / Math.cos(alpha);
    const horizontal = this.offset() / scaleY / Math.cos(beta);

    ctx.beginPath();
    this._setBorderDash(ctx);

    // Outer line.
    ctx.moveTo(0, -h / 2);
    ctx.lineTo(w / 2, 0);
    ctx.lineTo(0, h / 2);
    ctx.lineTo(-w / 2, 0);
    ctx.closePath();

    // Inner line.
    ctx.moveTo(0, -h / 2 + vertical);
    ctx.lineTo(w / 2 - horizontal, 0);
    ctx.lineTo(0, h / 2 - vertical);
    ctx.lineTo(-w / 2 + horizontal, 0);
    ctx.lineTo(0, -h / 2 + vertical);
    ctx.closePath();

    obj._renderPaintInOrder(ctx);
  }
}

export default ShapeWeakRelationship;

// as we near one, we expect disp to be grow
// as we expand, we expct disp to shrink
